module.exports = __webpack_public_path__ + "static/media/AtlasTypewriter-Regular-Web.f9ddc836.woff2";